import React from 'react';
import { Label, Button } from 'semantic-ui-react';
import { legendItems as defaultLegendItems } from '../../constants';

const Legend = ({ items = defaultLegendItems }) => {
  return (
    <div className="legend-container">
      <h4>Legend</h4>
      <div className="legend-items">
        {items.map((item, index) => (
          <div key={index} className="legend-item">
            <div className="legend-item-visual">
              {item.type === 'label' && (
                <Label
                  pointing={item.pointing}
                  className={item.borderClass}
                  style={{
                    textDecoration: item.text === 'Base Pay' ? 'underline' : 'none',
                    backgroundColor: item.color
                  }}
                >
                  {item.text}
                </Label>
              )}
              {item.type === 'circle' && (
                <Label circular style={{ backgroundColor: item.color }}>
                  {item.text}
                </Label>
              )}
              {item.type === 'button' && (
                <Button 
                  icon="info" 
                  size="mini" 
                  style={{ backgroundColor: item.color, color: 'black' }}
                >
                  {item.text}
                </Button>
              )}
              {item.type === 'text' && (
                <p
                  className={item.borderClass}
                  style={{ 
                    color: item.color,
                    textDecoration: item.text === 'Base Pay' ? 'underline' : 'none',
                    fontStyle: item.fontStyle || 'none'
                  }}
                >
                  {item.text}
                </p>
              )}
            </div>
            <span className="legend-description">{item.description}</span>
          </div>
        ))}
      </div>
    </div>
  );
};

export default Legend; 